import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"overflow":"auto","height":"calc(100% - 80px)"}
}
const _hoisted_2 = {
  key: 0,
  style: {"padding":"0px 12px 12px 12px"}
}
const _hoisted_3 = {
  class: "ph-picture",
  style: {"height":"250px"}
}
const _hoisted_4 = {
  key: 0,
  style: {"position":"relative","width":"100%","height":"250px","overflow":"hidden","border-radius":"6px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  style: {"overflow":"auto","height":"calc(100% - 80px)"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Stay open time")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Pre-Warning before opening time")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Pre-Warning before closing time")
const _hoisted_11 = {
  class: "btn btn-secondary btn_custom",
  type: "button",
  style: {"width":"100%","margin":"20px 0px"}
}
const _hoisted_12 = {
  key: 2,
  style: {"overflow":"auto","height":"calc(100% - 80px)"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 3,
  class: "custom-tabs"
}
const _hoisted_16 = { class: "tab-label" }
const _hoisted_17 = { class: "tab-label" }
const _hoisted_18 = { class: "tab-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_CameraWebRTCPlayer = _resolveComponent("CameraWebRTCPlayer")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: _ctx.darkMode ? 'dark' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('device')) + " - " + _toDisplayString(_ctx.device.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_buttons, { slot: "primary" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "danger",
                  fill: "outline",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-padding",
      style: {"position":"relative","background-color":"var(--ion-color-background)"}
    }, {
      default: _withCtx(() => [
        (_ctx.selectedTab == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.loadingCamera || _ctx.cameraMonitorId > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
                      [_vShow, _ctx.loadingCamera]
                    ]),
                    (_ctx.cameraMonitorId > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_CameraWebRTCPlayer, {
                            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                            autoplay: true,
                            muted: true,
                            controls: _ctx.isMobile(),
                            url: _ctx.cameraUrl,
                            cameraId: _ctx.cameraMonitorId,
                            style: {"position":"absolute","top":"0","bottom":"0","left":"0","right":"0"}
                          }, null, 8, ["controls", "url", "cameraId"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_b_row, { style: {"margin":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-success btn_custom",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.openGate();}),
                        style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                      }, _toDisplayString(_ctx.t('open_gate')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-danger btn_custom",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.closeGate();}),
                        style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px","background-color":"#39cc64","color":"white"}
                      }, _toDisplayString(_ctx.t('close_gate')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_row, { style: {"margin":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "floating" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('keep_open')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select, {
                            interface: "popover",
                            value: _ctx.keepOpenUntil,
                            onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.keepOpenUntil=$event.target.value)),
                            "ok-text": _ctx.t('SELECT.ok'),
                            "cancel-text": _ctx.t('SELECT.cancel')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "0" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('indefinitely')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "5" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('5_minutes')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "10" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('10_minutes')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "15" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('15_minutes')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "30" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('30_minutes')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "45" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('45_minutes')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "60" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('60_minutes')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value", "ok-text", "cancel-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-danger btn_custom",
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.triggerKeepGateOpen();}),
                        style: {"width":"100%","height":"65px","margin":"20px 0px","margin-top":"0px"}
                      }, _toDisplayString(_ctx.t('keep_gate_open')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createBlock(_component_b_row, {
                    key: 1,
                    style: {"margin":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn_custom",
                            type: "button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.lostTicket();}),
                            style: {"width":"100%","height":"150px","margin":"20px 0px","margin-top":"0px","background-color":"#39cc64","color":"white"}
                          }, _toDisplayString(_ctx.t('lost_ticket')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_b_table, {
                hover: "",
                outlined: "",
                responsive: "",
                busy: _ctx.events_loaded,
                items: _ctx.events_items,
                fields: _ctx.events_fields
              }, {
                "cell(name)": _withCtx((data) => [
                  _createTextVNode(_toDisplayString(_ctx.t(data.value)), 1)
                ]),
                "cell(description)": _withCtx((data) => [
                  _createTextVNode(_toDisplayString(_ctx.translate_description(data.value)), 1)
                ]),
                "cell(access_card)": _withCtx((data) => [
                  (data.value == null || typeof data.value.id == 'undefined' || data.value.id == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript: void(0);",
                        onClick: ($event: any) => (_ctx.openAccessCard(data.value.id))
                      }, _toDisplayString('#' + _ctx.t(data.value.id) + ' - ' + _ctx.t(data.value.username)), 9, _hoisted_6))
                ]),
                "cell(date_at)": _withCtx((data) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(data.value)), 1)
                ]),
                _: 1
              }, 8, ["busy", "items", "fields"]),
              _createVNode(_component_b_pagination, {
                modelValue: _ctx.events_page,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.events_page) = $event)),
                "total-rows": _ctx.events_rows,
                "per-page": 25
              }, null, 8, ["modelValue", "total-rows"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    type: "number",
                    min: 0,
                    max: 100,
                    value: _ctx.elka_settings.stay_open_time.toString(),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.elka_settings.stay_open_time = parseInt($event.target.value)))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    type: "number",
                    min: 0,
                    max: 100,
                    value: _ctx.elka_settings.prewarning_before_opening_time.toString(),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.elka_settings.prewarning_before_opening_time = parseInt($event.target.value)))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    type: "number",
                    min: 0,
                    max: 100,
                    value: _ctx.elka_settings.prewarning_before_closing_time.toString(),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.elka_settings.prewarning_before_closing_time = parseInt($event.target.value)))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (index) => {
                return _createVNode(_component_ion_item, {
                  key: `relay_operatingMode_${index}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { position: "floating" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('relay_operating_mode')) + " #" + _toDisplayString(index), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      value: _ctx.elka_settings.relay_operating_modes[index - 1],
                      onIonChange: ($event: any) => (_ctx.elka_settings.relay_operating_modes[index - 1] = $event.target.value),
                      "ok-text": _ctx.t('SELECT.ok'),
                      "cancel-text": _ctx.t('SELECT.cancel')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('deactivated')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "1" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('error')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('maintenance')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "3" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('boom_missing')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "4" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('tandem_operation')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "5" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('red_traffic_light')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "6" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('green_traffic_light')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "7" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('warning_light')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "8" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('led_boom_lighting')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "9" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_open')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "10" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_barrier_closed')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "11" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_via_bus')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "12" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('photoelectric_barrier_testing')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "13" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('barrier_emergency_released')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "14" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('presence')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "15" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_occupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "16" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_a_activated_notfaulty_notoccupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "17" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_occupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "18" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_a_cleared')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "19" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_occupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "20" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_b_activated_notfaulty_notoccupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "21" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_occupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "22" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_b_cleared')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "23" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_occupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "24" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_loop_c_activated_notfaulty_notoccupied')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "25" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_occupieday')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "26" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_loop_c_cleared')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "27" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_increment')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "28" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_vehicle_counter_decrement')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "29" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_left')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "30" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('pulse_when_dl_detected_passing_right')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "31" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('on_when_barrier_closed')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "32" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('on_when_tcp_connected')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "33" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('on_when_powerfailuredetection_connected_andnofailure')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "34" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('activated_when_acousticsignaldevice_ison')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "35" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_green_leds')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_select_option, { value: "36" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('ledboom_controlling_red_leds')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["value", "onIonChange", "ok-text", "cancel-text"])
                  ]),
                  _: 2
                }, 1024)
              }), 64)),
              _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.t('save_signals')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTab == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('type')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select, {
                    interface: "popover",
                    value: _ctx.type,
                    onIonChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.type=$event.target.value)),
                    "ok-text": _ctx.t('SELECT.ok'),
                    "cancel-text": _ctx.t('SELECT.cancel')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('none')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "Entrance gate" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Entrance gate')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "Exit gate" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('Exit gate')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "PAX Terminal" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('PAX Terminal')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "ELKA Barrier" }, {
                        default: _withCtx(() => [
                          _createTextVNode("ELKA " + _toDisplayString(_ctx.t('Barrier')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "AutomaticSystems Barrier" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Automatic Systems " + _toDisplayString(_ctx.t('Barrier')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "ok-text", "cancel-text"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('name')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    value: _ctx.name,
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.name=$event.target.value))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('brand')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    value: _ctx.brand,
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.brand=$event.target.value))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { position: "floating" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('model')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    value: _ctx.model,
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.model=$event.target.value))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    class: "item-has-value",
                    position: "floating"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('zones')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_select, {
                    interface: "popover",
                    modelValue: _ctx.zone_id,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.zone_id) = $event)),
                    onIonChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.zone_id=$event.target.value)),
                    "ok-text": _ctx.t('SELECT.ok'),
                    "cancel-text": _ctx.t('SELECT.cancel')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.all_zones, (zone) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: zone.id + '_short',
                          data: zone,
                          value: zone.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(zone.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["data", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "ok-text", "cancel-text"])
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "btn btn-secondary btn_custom",
                type: "button",
                onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.saveDeviceConfig();}),
                style: {"width":"100%","margin":"20px 0px"}
              }, _toDisplayString(_ctx.t('save_config')), 1),
              _hoisted_13,
              _hoisted_14,
              _createVNode(_component_b_row, { style: {"margin":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "btn btn-success btn_custom",
                        type: "button",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.reboot();}),
                        style: {"width":"100%","height":"75px","margin":"20px 0px","margin-top":"0px","background-color":"#f03a3e","color":"white"}
                      }, _toDisplayString(_ctx.t('reboot')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTechnician)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("a", {
                href: "javascript: void(0);",
                class: _normalizeClass(_ctx.selectedTab == 1 ? 'tab selected' : 'tab'),
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectTab(1)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.list }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('overview')), 1)
              ], 2),
              _createElementVNode("a", {
                href: "javascript: void(0);",
                class: _normalizeClass(_ctx.selectedTab == 2 ? 'tab selected' : 'tab'),
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectTab(2)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.gitNetwork }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('signals')), 1)
              ], 2),
              _createElementVNode("a", {
                href: "javascript: void(0);",
                class: _normalizeClass(_ctx.selectedTab == 3 ? 'tab selected' : 'tab'),
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectTab(3)))
              }, [
                _createVNode(_component_ion_icon, { icon: _ctx.cog }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('configuration')), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}